import permissions from "app/permissions";
import { administrationRequests } from "api/administrationApi";
import { graduationRequests } from "api/graduationApi";
import React from "react";
import {
  Datagrid,
  FunctionField,
  List,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ShowButton,
  SimpleList,
  TextField,
  TextInput,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import { formatStudentOption } from "../utils";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { MOBILE_BREAKPOINT } from "utils/constants";

const ListInternshipStudents = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const filters = [
    <ReferenceInput
      source="planId"
      reference={graduationRequests.getInternshipPlansSelect()}
      alwaysOn
    >
      <SelectInput
        optionText="name"
        label="Стажантски план"
        emptyText={false}
        style={{ width: 300 }}
      />
    </ReferenceInput>,
    <ReferenceInput
      source="specialityId"
      reference={administrationRequests.getSpecialitiesSelect()}
      filter={{ filterByUser: true }}
      alwaysOn
    >
      <SelectInput
        optionText="name"
        label="Специалност"
        emptyText={false}
        style={{ width: 300 }}
      />
    </ReferenceInput>,
    <TextInput
      source="studentName"
      label="Име на студент"
      alwaysOn
    />,
    <TextInput
      source="facultyNumber"
      label="Факултетен номер"
      alwaysOn
    />,
  ];
  return (
    <List
      exporter={false}
      title="Студенти"
      filters={filters}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име", value: formatStudentOption(false)(record) }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[{ label: "Факултетен номер", value: record?.studentInfo?.facultyNumber }]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Специалност",
                    value: (
                      <ReferenceField
                        source="specialityId"
                        reference={administrationRequests.getSpecialitiesSelect()}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Стажантски план",
                    value: (
                      <ReferenceField
                        source="planId"
                        reference={graduationRequests.getInternshipPlansSelect()}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={record => (
            <SecuredComponent permission={permissions.canPreviewInternshipStudents}>
              <ShowButton
                label=""
                record={{ ...record, id: record?.studentEducationId }}
              />
            </SecuredComponent>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <FunctionField
            label="Име"
            sortable={false}
            render={formatStudentOption(false)}
          />
          <TextField
            source="studentInfo.facultyNumber"
            label="Факултетен номер"
            sortable={false}
          />
          <ReferenceField
            source="specialityId"
            reference={administrationRequests.getSpecialitiesSelect()}
            sortable={false}
            label="Специалност"
          >
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField
            source="planId"
            reference={graduationRequests.getInternshipPlansSelect()}
            sortable={false}
            label="Стажантски план"
          >
            <TextField source="name" />
          </ReferenceField>
          <FunctionField
            render={record => (
              <SecuredComponent permission={permissions.canPreviewInternshipStudents}>
                <ShowButton record={{ ...record, id: record?.studentEducationId }} />
              </SecuredComponent>
            )}
          />
        </Datagrid>
      )}
    </List>
  );
};

export default ListInternshipStudents;
